import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';

export const failureKind = (status) => [400, 404].includes(status)
  ? 'notFound' : [401, 403].includes(status) ? 'restricted' : 'unavailable';

const messages = {
  notFound: ['Nie znaleziono strony', 'Podany adres nie prowadzi do dostępnej strony. Sprawdź adres lub wybierz rozgrywki z menu.'],
  unavailable: ['Nie udało się pobrać danych', 'Wystąpił chwilowy problem z połączeniem lub serwerem. Spróbuj ponownie.'],
  restricted: ['Dostęp wymaga uprawnień', 'Zaloguj się i sprawdź uprawnienia swojego konta.'],
  unsupported: ['Strona drużyny jest niedostępna', 'Strony drużyn dostępne są dla klubów z obsługiwanych polskich lig.'],
};

export default function PageStatus({ kind = 'notFound' }) {
  const [title, message] = messages[kind] || messages.notFound;
  return (
    <Box sx={{ textAlign: 'center', py: 8, px: 2 }}>
      <Helmet>
        <title>{title} | SymuLiga</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Typography component="h1" variant="h5" gutterBottom>{title}</Typography>
      <Typography color="text.secondary">{message}</Typography>
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 3 }}>
        <Button component={Link} to="/">Strona główna</Button>
        {kind === 'unavailable' && <Button onClick={() => window.location.reload()}>Spróbuj ponownie</Button>}
        {kind === 'restricted' && <Button component={Link} to="/login">Zaloguj się</Button>}
      </Stack>
    </Box>
  );
}
